var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"list-mode":"","title":_vm.Info.Section.Variant.Title}},[_c('List',{attrs:{"userVariantList":_vm.userVariantList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }